<template>
  <div class="my-3">
    <v-row class="mt-2">
      <v-col cols="12" align="right">
        <v-btn elevation="0" outlined @click="createNewGroup">
          <v-icon>mdi-plus</v-icon>Dodaj nową grupę</v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-data-table
          :headers="headers"
          :items="data || []"
          item-key="id"
          :expanded.sync="expanded"
          show-expand
          dense
          class="elevation-1 full-width-table"
          :loading="loading"
          loading-text="Wczytywanie danych grup..."
          :items-per-page="10"
          :footer-props="{
            'items-per-page-options': [10, 20, 50, -1],
            'items-per-page-text': 'Grup na stronie:'
          }"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" class="py-1">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Szukaj grupy"
                single-line
                hide-details
                class="ml-2"
                clearable
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn icon color="primary" @click="refreshGroups" class="mr-1" title="Odśwież dane">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          
          <template v-slot:item.componentList.length="{ item }">
            <span>{{ item.componentList ? item.componentList.length : 0 }}</span>
          </template>
          
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="groupEdit(item)" title="Edytuj grupę">
              mdi-pencil
            </v-icon>
            <v-icon small @click="checkStocksForGroup(item)" title="Sprawdź stany">
              mdi-database-check
            </v-icon>
          </template>
          
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-0">
              <v-card flat class="pa-3 grey lighten-4">
                <v-row no-gutters align="center" class="mb-2">
                  <v-col>
                    <h3 class="subtitle-1">Komponenty w grupie: {{ item.name }}</h3>
                  </v-col>
                  <v-col cols="auto">
                    <div class="d-flex align-center">
                      <v-btn 
                        small 
                        outlined 
                        color="primary" 
                        @click="checkStocksForGroup(item)"
                        :loading="stocksLoading[item.id]"
                        class="mr-2"
                      >
                        <v-icon small left>mdi-database-check</v-icon>
                        Sprawdź stany
                      </v-btn>
                      <v-btn small color="primary" text @click="groupEdit(item)">
                        <v-icon small left>mdi-pencil</v-icon>
                        Edytuj grupę
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                
                <v-simple-table dense v-if="item.componentList && item.componentList.length > 0">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Nazwa</th>
                        <th class="text-left">ID Wfirma</th>
                        <th class="text-left">Kod producenta</th>
                        <th class="text-center">Dystrybutorzy</th>
                        <th class="text-center" v-if="stocksData[item.id]">Stan</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="component in item.componentList" :key="component.id" :class="{'green lighten-5': isComponentAvailable(item.id, component.warehouseId)}">
                        <td>{{ component.name }}</td>
                        <td>
                          <a 
                            :href="`https://wfirma.pl/goods/view/${component.warehouseId}`" 
                            target="_blank"
                          >{{ component.warehouseId }}</a>
                        </td>
                        <td>{{ component.mpn || '-' }}</td>
                        <td class="text-center">
                          <img
                            v-for="distributor in component.selectedDistributors"
                            :key="distributor"
                            :src="require(`@/assets/icons/${distributor.toLowerCase()}.png`)"
                            height="14px"
                            width="14px"
                            style="margin-right: 5px"
                            :title="distributor"
                          />
                        </td>
                        <td class="text-center" v-if="stocksData[item.id]">
                          {{ getStockForComponent(item.id, component.warehouseId) }}
                        </td>
                      </tr>
                      <tr v-if="stocksData[item.id]" style="background-color: #ededed">
                        <td class="text-right" colspan="4"><b>DOSTĘPNE:</b></td>
                        <td class="text-center">
                          <b>
                            {{ getSumForGroup(item.id) }} / {{ item.requiredCount }} =
                            {{ Math.floor(getSumForGroup(item.id) / item.requiredCount) }}
                            szt.
                          </b>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <p v-else class="text-center subtitle-2 mt-3 grey--text">
                  Brak komponentów w tej grupie
                </p>
              </v-card>
            </td>
          </template>
          
          <template v-slot:no-data>
            <v-alert 
              type="info" 
              text 
              outlined
              class="ma-4"
            >
              Brak danych. Dodaj nową grupę komponentów.
            </v-alert>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <component-group-modal
      v-model="showComponentGroupModal"
      :data="componentGroupData"
      @saved="refreshGroups"
    />
  </div>
</template>

<script>
import ComponentGroupModal from "../components/ComponentGroupModal.vue";

export default {
  name: "component-groups",
  components: { ComponentGroupModal },
  methods: {
    getComponentGroups() {
      this.loading = true;
      this.$store
        .dispatch("getComponentGroups")
        .then((response) => {
          if (response.data && response.data.content) {
            // Set base data
            this.data = response.data.content;
            
            // Process component details for components if needed
            this.processComponentGroups();
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "error",
            text: "Something went wrong with getComponentGroups()",
          });
          this.loading = false;
        });
    },
    
    processComponentGroups() {
      // Check if componentList is missing from any group
      const missingComponentLists = this.data.filter(group => !group.componentList);
      
      if (missingComponentLists.length === 0) {
        // All groups have componentList already
        this.loading = false;
        return;
      }
      
      // Create an array of promises for fetching component details
      const promises = this.data.map(group => {
        // Only fetch details if componentList is not present
        if (!group.componentList) {
          return this.$store.dispatch("getComponentGroupDetails", { id: group.id })
            .then(response => {
              // Update group with details
              const index = this.data.findIndex(g => g.id === group.id);
              if (index !== -1 && response.data) {
                this.$set(this.data, index, response.data);
              }
              return response;
            })
            .catch(error => {
              console.error(`Failed to fetch details for group ${group.id}:`, error);
              return null;
            });
        }
        return Promise.resolve(null); // Return resolved promise for groups that already have componentList
      });
      
      // Process all promises
      Promise.all(promises)
        .finally(() => {
          this.loading = false;
        });
    },
    
    groupEdit(item) {
      this.componentGroupData = {
        ...item,
        requiredCount: item.requiredCount?.toString() || "0"
      };
      this.showComponentGroupModal = true;
    },
    
    createNewGroup() {
      this.componentGroupData = {
        id: null,
        name: "",
        requiredCount: "0",
        componentList: []
      };
      this.showComponentGroupModal = true;
    },
    
    refreshGroups() {
      this.getComponentGroups();
      // Clear stocks data when refreshing groups
      this.stocksData = {};
      this.stocksLoading = {};
    },
    
    checkStocksForGroup(group) {
      // Skip if no components
      if (!group.componentList || group.componentList.length === 0) {
        this.$store.dispatch("snackbar/setSnackbar", {
          color: "warning",
          text: "Brak komponentów w tej grupie"
        });
        return;
      }
      
      // Set loading state for this group
      this.$set(this.stocksLoading, group.id, true);
      
      // If this group is not already expanded, expand it
      if (!this.expanded.includes(group.id)) {
        this.expanded.push(group.id);
      }
      
      this.$store
        .dispatch("getWfirmaStocks", {
          body: JSON.stringify(group.componentList),
        })
        .then((success) => {
          // Store the stock data for this specific group
          this.$set(this.stocksData, group.id, success.data);
          
          // Calculate availability
          const sum = this.getSumForGroup(group.id);
          const available = Math.floor(sum / group.requiredCount);
          
          // Show success message with availability info
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "success",
            text: `Stany pobrane: dostępnych ${available} kompletnych zestawów`,
          });
        })
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "error",
            text: "Wystąpił problem z pobieraniem stanów",
          });
        })
        .finally(() => {
          // Clear loading state for this group
          this.$set(this.stocksLoading, group.id, false);
        });
    },
    
    getStockForComponent(groupId, warehouseId) {
      if (!this.stocksData[groupId]) return "-";
      
      const product = this.stocksData[groupId].find(p => p.warehouseId == warehouseId);
      if (product) {
        return `${product.sum} szt.`;
      } else {
        return "Nie znaleziono!";
      }
    },
    
    getSumForGroup(groupId) {
      if (!this.stocksData[groupId]) return 0;
      
      let sum = 0;
      const group = this.data.find(g => g.id === groupId);
      if (!group || !group.componentList) return 0;
      
      group.componentList.forEach(item => {
        const product = this.stocksData[groupId].find(p => p.warehouseId == item.warehouseId);
        if (product) {
          sum += product.sum;
        }
      });
      
      return sum;
    },
    
    isComponentAvailable(groupId, warehouseId) {
      if (!this.stocksData[groupId]) return false;
      
      const product = this.stocksData[groupId].find(p => p.warehouseId == warehouseId);
      return product && product.sum > 0;
    }
  },
  data() {
    return {
      data: null,
      loading: false,
      showComponentGroupModal: false,
      componentGroupData: null,
      expanded: [],
      stocksData: {}, // Object to store stock data by group ID
      stocksLoading: {}, // Object to track loading state by group ID
      search: '', // For searching groups
      headers: [
        {
          text: 'Nazwa grupy',
          align: 'start',
          value: 'name',
          class: 'primary--text font-weight-bold',
        },
        { 
          text: 'Wymagana liczba sztuk', 
          value: 'requiredCount',
          align: 'center',
          width: '200px'
        },
        { 
          text: 'Liczba komponentów', 
          value: 'componentList.length',
          align: 'center',
          width: '200px'
        },
        { 
          text: 'Akcje', 
          value: 'actions', 
          sortable: false,
          align: 'center',
          width: '120px'
        },
        { 
          text: '', 
          value: 'data-table-expand',
          width: '54px'
        }
      ],
    };
  },
  mounted() {
    this.getComponentGroups();
  },
};
</script>

<style scoped>
a {
  color: inherit;
  text-decoration: underline;
}

.full-width-table {
  width: 100%;
}

/* Make sure expanded content takes full width */
::v-deep .v-data-table__expanded__content {
  box-sizing: border-box;
  width: 100%;
}

/* Fix column widths */
::v-deep .v-data-table th {
  white-space: nowrap;
}

::v-deep .v-data-table td {
  white-space: normal;
}

/* Highlight hoverable rows */
::v-deep .v-data-table tr:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

/* Make expand button more visible */
::v-deep .v-data-table__expand-icon {
  margin-right: 8px;
}
</style>
